<template>
  <ac-modal :title="'Send Reminder'" :size-class="'modal-md'" ref="modalRef">
    <template>
      <form v-if="widgetReady">
        <div class="row">
          <div class="info-board info-board-blue" style="margin: 0 0 20px 0">
            <p>Do you want to send a reminder to {{ vm.fullName }} asking them to complete their
              account setup?</p>
          </div>
        </div>
      </form>
    </template>
    <template slot="buttons">
      <ac-button class="btn btn-sm btn-red margin-gutters" :action="closeModal">
        CANCEL
      </ac-button>
      <ac-button class="btn btn-sm btn-green margin-gutters" :action="sendReminderEmail">
        SEND
      </ac-button>
    </template>
  </ac-modal>
</template>



<script>
import { api } from "../../global/framework/api.js";
import { common } from "../../global/common.js";
import { notifications } from "../../global/notifications.js";

export default {
  name: "SendReminderEmailModal",
  data() {
    return {
      vm: { fullName: String, consumerId: Number },
      widgetReady: false
    }
  },
  computed: {
    vmRef() {
      return this.$data;
    }
  },
  methods: {
    async showModal({ consumerId: consumerId, fullName: fullName, controller: controller}) {      
      this.vm = { fullName, consumerId, controller };
      this.widgetReady = true;
      this.$refs.modalRef.open();
    },
    closeModal() {
      this.$refs.modalRef.close();
    },
    async sendReminderEmail() {      
      let result = await api.post(this.vm.controller, 'SendEmailReminder/' + this.vm.consumerId, {}, true);

      console.log("result: ", { result: result });
      if (result.data)
        notifications.show({ title: "Success!", message: "Successfully sent email reminder to " + this.vm.fullName + "." }, common.ACRESSA_NOTIFICATIONS.SUCCESS);
      else
        notifications.show({ title: "Failure!", message: "Failed to send email reminder to " + this.vm.fullName + "." }, common.ACRESSA_NOTIFICATIONS.ERROR);

      this.closeModal();
    }
  }


}
</script>

<style scoped></style>